import { getSessionByToken } from '@/api/login.js';

export default function jsbridge () {}

/**
 * 检测当前浏览器是Android(Chrome) 还是iOS
 */

var ua = navigator.userAgent;
jsbridge.isIPhone = function () {
    if (ua.indexOf('iPhone') > -1) {
        return true;
    }
    return false;
};

jsbridge.isAndroid = function () {
    if (ua.indexOf('Android') > -1) {
        return true;
    }
    return false;
};

/**
 * 链接webView试图浏览器
*/

jsbridge.connectWebViewJavascriptBridge = function (callback) {
    if (window.WebViewJavascriptBridge) {
        return callback(window.WebViewJavascriptBridge);
    }
    if (window.WVJBCallbacks) {
        return window.WVJBCallbacks.push(callback);
    }
    window.WVJBCallbacks = [callback];
    var WVJBIframe = document.createElement('iframe');
    WVJBIframe.style.display = 'none';
    WVJBIframe.src = 'gomescheme://__BRIDGE_LOADED__';
    // WVJBIframe.src = 'gomefinancescheme://__BRIDGE_LOADED__';
    document.documentElement.appendChild(WVJBIframe);
    setTimeout(function() {
        document.documentElement.removeChild(WVJBIframe);
    }, 0);
    // callback();
};


/**
 *  跳转登录页面
 */

jsbridge.reLogin = function () {
    jsbridge.connectWebViewJavascriptBridge(function(bridge) {
        // js 调用 native    方法名       参数     返回数据
        bridge.callHandler('gome_login', '', function(response) {
            // 调用重新登录
            window.location.replace(response);
            if(response === 'cancel'){
                jsbridge.close();
            }
            return response;
        });
    });
};

jsbridge.reLoginAvli = function () {
    jsbridge.connectWebViewJavascriptBridge(function(bridge) {
        // js 调用 native
        bridge.callHandler('gome_login', 'invalidAccessToken', function(response) {
            // 调用重新登录
            return response;
        });
    });
};

/**
 *  关闭当前webView
 */
jsbridge.close = function () {
    jsbridge.connectWebViewJavascriptBridge(function(bridge) {
        // js 调用 native
        bridge.callHandler('gome_close', '', function(response) {
            // 关闭当前webView
        });
    });
};

/**
 *  启动新的webView页面
 */
jsbridge.go2SecondPage = function (data) {
    jsbridge.connectWebViewJavascriptBridge(function(bridge) {
        // js 调用 native
        bridge.callHandler('gome_secondpage', data, function(response) {
            // 启动新的webView页面
        });
    });
};

/**
 *  启动外部浏览器
 */
jsbridge.dowloadPdf = function (data) {
    jsbridge.connectWebViewJavascriptBridge(function (brige) {
        brige.callHandler('gome_download' , data, function (response) {

        });
    });
};

/**
 *  返回上一页
 */
jsbridge.goBack = function () {
    jsbridge.connectWebViewJavascriptBridge(function (brige) {
        brige.callHandler('gome_back' , '', function (response) {

        });
    });
};

/**
 *  控制网页左侧返回键显示隐藏
 */
jsbridge.left = function (data) {
    jsbridge.connectWebViewJavascriptBridge(function(bridge) {
        // js 调用 native
        bridge.callHandler('gome_left', data, function(response) {
            // 控制左侧按钮操作
        });
    });
};

/**
 *  控制右侧按钮操作
 */
jsbridge.right = function (data) {
    jsbridge.connectWebViewJavascriptBridge(function(bridge) {
        // js 调用 native
        bridge.callHandler('gome_right', data, function(response) {
            // 控制右侧按钮操作
        });
    });
};

/**
 *  调取分享、控制title上右侧按钮显示分享按钮，点击分享
 */
jsbridge.goShare = function (data) {
    jsbridge.connectWebViewJavascriptBridge(function(bridge) {
        // js 调用 native
        bridge.callHandler('gome_share', data, function(response) {
            //分享
            response();
        });
    });
};

/**
 *  调取微信支付
 */
jsbridge.wxPay = function (data) {
    jsbridge.connectWebViewJavascriptBridge(function (brige) {
        brige.callHandler('gome_insured_wxpay' , data, function (response) {
            //alert('支付结果：' + response);
            return new Promise((resolve)=>{
                resolve(response);
            });
        });
    });
};

/**
 *  调取支付宝支付
 */
jsbridge.aliPay = function (data) {
    jsbridge.connectWebViewJavascriptBridge(function (brige) {
        brige.callHandler('gome_insured_alipay' , data, function (response) {

        });
    });
};
/**
*  跳转国美金融App首页
*/
jsbridge.goIndex = function (data) {
    jsbridge.connectWebViewJavascriptBridge(function (brige) {
        brige.callHandler('gome_go_index' , data , function (response) {

        });
    });
};

// 国美金融敏感信息加密需求新增获取aesUuid , aes秘钥
jsbridge.getAesSecretKey = function () {
    return new Promise((resolve,reject)=>{
        setTimeout(() =>{
            jsbridge.connectWebViewJavascriptBridge(function (bridge) {
                bridge.callHandler('gome_getAesSecretKey', { flag:true }, (response)=> {
                    // alert('返回结果：' + response)
                    resolve(response);
                });
            });
        },500);
    });
};


/**
 * login登录
 * @param data
 * @param callback
 */
jsbridge.checkLogin = function (accessToken, callback) {
    alert('进入checkLogin，accessToken:' + accessToken);
    if(accessToken && typeof accessToken != 'undefined'){
        getSessionByToken(accessToken).then((result)=>{
            if(result && result.success){
                localStorage['inviterOwn'] = result.data.userInfo.id;
                callback();
            }else{
                jsbridge.appLogin(callback);
            }
        });
    }else{
        jsbridge.appLogin(callback);
    }
};
//置换登陆态，若无token则不操作
jsbridge.checkLoginRelogin = function (accessToken, callback) {
    //alert('进入checkLogin，accessToken:' + accessToken);
    if(accessToken && typeof accessToken != 'undefined'){
        getSessionByToken(accessToken).then((result)=>{
            if(result && result.success){
                localStorage['inviterOwn'] = result.data.userInfo.id;
                callback();
            }else{
                jsbridge.reLogin();
            }
        });
    }else{
        jsbridge.reLogin();
    }
};

jsbridge.setHeader = function({ title = '保险产品', titleColor = '#000000', backgroundColor = '#ffffff', backNav = 'black', borderHidden = true, closeNav = null }){
    return new Promise(function (resolve, reject) {
        jsbridge.connectWebViewJavascriptBridge(function (bridge) {
            bridge.callHandler('gome_title' , { title, titleColor, backgroundColor, backNav, borderHidden, closeNav } , function (response) {
                resolve(response);
            });
        });
    });
};

jsbridge.appLogin = function (callback) {
    jsbridge.connectWebViewJavascriptBridge(function (bridge) {
        bridge.callHandler('gome_login' , '' , function (response) {
            if(response && response != ''){
                if(response.indexOf('accessToken=') != -1){
                    let index = response.indexOf('accessToken=');
                    let accessToken = response.substring(index + 'accessToken'.length + 1, response.length);
                    sessionStorage['accessToken'] = accessToken;
                    if(accessToken && accessToken != ''){
                        getSessionByToken(accessToken).then((result)=>{
                            if(result && result.success){ //登录成功
                                localStorage['inviterOwn'] = result.data.userInfo.id;
                                callback();
                            }
                        });
                    }
                }
            }
        });
    });
};



// WEBPACK FOOTER //
// ./src/utils/jsbridge/jsbridge.js